import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { captureUmamiAttribution } from "@/lib/umamiAnalytics";

// Temporary, opt-in promo capture skin. It is deliberately inert unless the
// explicit query flag is present, so normal product rendering is unchanged.
if (new URLSearchParams(window.location.search).get("promoScreenshot") === "1") {
  document.documentElement.classList.add("promo-screenshot-mode");
}

captureUmamiAttribution();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
